
import LedSearchFormLicencePlate from '@/components/LedSearchFormLicencePlate.vue'

export default {
  name: 'CategoryHubFinder',
  components: { LedSearchFormLicencePlate },
  props: {
    layout: {
      type: String,
      default: 'card',
    },
  },
  data() {
    return {
      searching: false,
    }
  },
  computed: {
    vehicle() {
      return this.$store.getters.selected_vehicle
    },
    vehicleLabel() {
      if (!this.vehicle) return ''
      return `${this.vehicle.brand?.name || ''} ${this.vehicle.name}`.trim()
    },
    vehicleUrl() {
      if (!this.vehicle?.brand) return null
      return this.localePath({
        name: 'recherche-led-accessoires-brand-type-typeid',
        params: {
          brand: this.$slugify(this.vehicle.brand.name).toLowerCase(),
          type: this.$slugify(this.vehicle.name).toLowerCase(),
          typeid: this.vehicle.id,
        },
      })
    },
  },
}
